import dayjs from "dayjs";
import {
  IChartDataState,
  IChartDataStateValues,
  IChartStoredStateValues,
  IEpochTimeRange,
  ITimeRange,
  StoredChartValues,
} from "../../data_point/charts/ChartModel";
import { IStringToTimeValueListDictionary } from "../../data_point/models/TagsModels";
export const serializeChartRange = (range: ITimeRange): IEpochTimeRange => ({
  start: range.start.valueOf(),
  end: range.end.valueOf(),
});
export const chartRangeView = (range: IEpochTimeRange, timeZone?: string): ITimeRange => ({
  start: timeZone ? dayjs(range.start).tz(timeZone) : dayjs(range.start),
  end: timeZone ? dayjs(range.end).tz(timeZone) : dayjs(range.end),
});
export const serializeChartValues = (values: IStringToTimeValueListDictionary): StoredChartValues =>
  Object.fromEntries(
    Object.entries(values).map(([tag, samples]) => [
      tag,
      samples.map((sample) => ({
        value: Number.isFinite(sample.value) ? sample.value : null,
        time: sample.time.valueOf(),
      })),
    ])
  );
const chartValuesViews = new WeakMap<StoredChartValues, IStringToTimeValueListDictionary>();
function chartValuesView(values: StoredChartValues): IStringToTimeValueListDictionary {
  let view = chartValuesViews.get(values);
  if (!view) {
    view = Object.fromEntries(
      Object.entries(values).map(([tag, samples]) => [
        tag,
        samples.map((sample) => ({ value: sample.value ?? NaN, time: new Date(sample.time) })),
      ])
    );
    chartValuesViews.set(values, view);
  }
  return view;
}
const chartSiteViews = new WeakMap<Record<string, IChartStoredStateValues>, IChartDataState>();
const chartEntryViews = new WeakMap<IChartStoredStateValues, IChartDataStateValues>();
function chartEntryView(entry: IChartStoredStateValues): IChartDataStateValues {
  let view = chartEntryViews.get(entry);
  if (!view) {
    view = {
      ...entry,
      rangeTime: chartRangeView(entry.rangeTime, entry.siteTimeZone),
      tagToValues: chartValuesView(entry.tagToValues),
    };
    chartEntryViews.set(entry, view);
  }
  return view;
}
export function chartSiteView(
  site: Record<string, IChartStoredStateValues> | undefined
): IChartDataState | undefined {
  if (!site) {
    return undefined;
  }
  let view = chartSiteViews.get(site);
  if (!view) {
    view = Object.fromEntries(Object.entries(site).map(([key, entry]) => [key, chartEntryView(entry)]));
    chartSiteViews.set(site, view);
  }
  return view;
}
